import IndexPage from './pages/IndexPage'
import LoginPage from './pages/LoginPage'

function App() {
  const path = window.location.pathname

  if (path === '/login') {
    return <LoginPage />
  }

  return <IndexPage />
}

export default App
